import React from 'react';

import {defineMessages, useIntl} from 'react-intl';
import {useNavigate} from 'react-router-dom';
import {useMutation} from 'react-query';

import API, {useCsrfToken} from '@wheeebo/polaris-api';
import {DeleteCard, useErrorHandler} from '@wheeebo/polaris-ui';

const msgs = defineMessages({
  alertTitle: {
    id: 'pages.member.settings.AccountDeleteCard.alert.title',
    defaultMessage: 'Delete account',
  },
});

function AccountDeleteCard(): JSX.Element {
  const intl = useIntl();
  const {csrfToken} = useCsrfToken();
  const {showAndEmitJsErrorEvent} = useErrorHandler();
  const navigate = useNavigate();
  const {mutate: accountDelete} = useMutation<unknown, unknown>(() => API.Accounts.delete_(csrfToken), {
    onSuccess: () => navigate('/'),
    onError: showAndEmitJsErrorEvent,
  });
  return <DeleteCard title={intl.formatMessage(msgs.alertTitle)} onDelete={() => accountDelete()} />;
}
export default React.memo(AccountDeleteCard);
